import { t } from "i18next";

import { CustomerFolderTypeCode, MessageThreadTitle } from "src/core/constants/folder";
import { Status } from "src/core/constants/folders";
import { CustomRiskLevel } from "src/core/constants/risk";
import { FolderFile, FolderFileQuery } from "src/core/gql/graphql";
import { mapContact, mapOwner } from "src/core/mappers/contact.mapper";
import { getFolderFieldValue } from "src/core/mappers/folder.mapper";
import { mapRiskLevelToCustomRiskLevel } from "src/core/mappers/risk.mapper";
import { dateFolderFinished } from "src/core/utils/folder";
import { mapCodeToCustomStatus } from "src/core/utils/status";

/**
 * @description Map une requête de dossier vers un modèle de header.
 * @param query - Query de dossier @see {@link FolderFileQuery}
 */
export const mapFolderFileQueryToHeaderModel = (query: NonNullable<FolderFileQuery>) => {
  const folderFile = query.folderFile;
  const stateCode = folderFile?.workflowStatus?.state?.code;
  const state = mapCodeToCustomStatus(stateCode);
  const isPerson =
    folderFile?.currentCustomerFolder?.customerFolderType?.code === CustomerFolderTypeCode.PPH;
  const globalRisk = mapRiskLevelToCustomRiskLevel(folderFile?.riskStatus?.globalRiskLevel);
  const isRiskForced = Boolean(folderFile?.riskStatus?.forcedRisk);
  const finishedDate = folderFile ? dateFolderFinished(folderFile as unknown as FolderFile) : null;
  const hasComments =
    folderFile?.messageThreads?.some((thread) => thread.title === MessageThreadTitle.COMMENTS) ??
    false;

  const folderRisks =
    state === Status.DRAFT ||
    state === Status.VALIDATION_PENDING ||
    state === Status.VALIDATION_PENDING_HR
      ? { global: CustomRiskLevel.IN_PROGRESS }
      : { global: globalRisk };

  const name = !isPerson
    ? getFolderFieldValue(query, "name")
    : getFolderFieldValue(query, "firstName") === t("form.createClient.emptyPPHName") ||
      getFolderFieldValue(query, "lastName") === t("form.createClient.emptyPPHName")
    ? t("form.createClient.emptyPPHName")
    : getFolderFieldValue(query, "firstName") + " " + getFolderFieldValue(query, "lastName");

  return {
    customerFolderId: folderFile?.currentCustomerFolder?.id,
    name,
    contactPerson: mapContact(query),
    owner: mapOwner(query),
    state: mapCodeToCustomStatus(stateCode),
    isRiskForced,
    finishedDate,
    hasComments,
    folderRisks,
    globalRisk,
    isPerson,
  };
};
